import React, { useEffect, useState } from 'react';
import QRCode from "react-qr-code";
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import { Row, Col } from 'react-bootstrap'

const RFStudentQRCode = props => {
    let [isDone, setIsDone] = useState(false);
    let [qrLink, setQrLink] = useState('');
    let [ctDNone, setCtDNone] = useState('d-none');
    useEffect(() => {
        try {  
            UserService.getRiasecResult(AuthService.getCurrentRoomId(), AuthService.getCurrentUserId(), 'STUDENT')
            .then((response) => { 
                if (response.data && response.data.data && response.data.data[0]) {
                    setIsDone(true);
                }
            })
        } catch (error) {
        }
        try {  
            UserService.getRiasecResult(AuthService.getCurrentRoomId(), AuthService.getCurrentUserId(), 'PARENT')
            .then((response) => { 
                let link = `riasec/evaluate/${AuthService.getCurrentUserId()}/parent`
                if (response.data && response.data.data && response.data.data[0]) {
                    link = `report/riasec/${AuthService.getCurrentRoomId()}/${AuthService.getCurrentUserId()}/parent`
                }
                setQrLink(`${process.env.REACT_APP_URL}${link}`)
            })
        } catch (error) {
        }
        
    }, []);
    

    function copyToClipboard() {
        var copyText = document.getElementById("content").value;
        navigator.clipboard.writeText(copyText).then(() => {
            setCtDNone('');
            setTimeout(() => { setCtDNone('d-none'); }, 5000)
        });
      }

    return (
        <div className='riasec-qr-page main-detail'>  
   
            <Row className=''>
                <Col xs={12} className="ev-header text-center main-detail px-0">
                    <div className='position-relative'>
                        <img src='/images/riasec/dk-qr-header.png' className='d-none d-lg-block' width={'100%'} alt='qr-header'/>     
                        <img src='/images/riasec/mb-qr-header.png' className='d-block d-lg-none' width={'100%'} alt='qr-header' />
                    <div className='banner-detail position-absolute text-center'>
                        <h2 className='font-sarabun-bold'>ทำแบบประเมินกันเลย!!</h2>
                        <p><a href={`/riasec/evaluate/${AuthService.getCurrentUserId()}`} type="button" className={`start-evaluate font-sarabun-bold text--black ${isDone?'d-none' : ''}`}>เริ่มประเมิน</a> </p>
                        <p><a href={`/report/riasec/${AuthService.getCurrentRoomId()}/${AuthService.getCurrentUserId()}`} type="button" className={`start-evaluate font-sarabun-bold text--black  ${isDone?'' : 'd-none'}`}>ดูผลประเมิน</a> </p>                    
                    </div>
                    <div className='w-100 position-absolute mascot'>
                        <img src='/images/riasec/mascot.png' className='mascot' alt='mascot' />  
                    </div>
                    </div>
                </Col>
                <Col xs={12} className="qr-detail pb-2 px-3">
                    <h2 className='font-sarabun-bold primary-text text-center'>ส่วนของผู้ปกครอง</h2>
                    <h3 className='font-sarabun grey-dark-text pt-3'>อย่าลืม!! ชวนผู้ปกครองเข้ามาทำประเมินผ่าน QR Code ด้านล่าง</h3>
                    <span className='font-sarabun-bold text-notice pt-2'>** ทำได้ปีละ 1 ครั้งจ้า **</span>
                    <div className='w-100 text-center'>
                        { (qrLink) ? (
                            <div>
                                    <div className='d-none d-lg-inline-flex position-relative'>
                                        <img src='/images/riasec/qrcode-frame.png' className="pt-3 qrcode-frame " alt='qrcode' />      
                                        <QRCode value={qrLink} className='qr-code' size="152" />
                                    </div>
                                    <div className='frame d-inline d-lg-none position-relative'>
                                        <img src='/images/riasec/qrcode-frame.png' className="pt-3 qrcode-frame " alt='qrcode' />     
                                        <QRCode value={qrLink} className='qr-code' size="90" />
                                    </div> 
                                    <div xs={12} className=" mb-5">
                                        <textarea id="content" className='d-none'>{qrLink}</textarea>
                                        <button onClick={() => copyToClipboard()} className="bg-lightness4-blue  border-0px click-pointer btn font-sarabun-bold mt-3 font-sarabun-bold text--black">คัดลอก</button>
                                        <p className={`${ctDNone} copied-text mt-1`}>คัดลอกลิงค์เรียบร้อยแล้ว</p>
                                    </div>                               
                            </div>
                        ) : (
                            <div />
                        )}
                    </div>
                    {/* {process.env.REACT_APP_URL}riasec/evaluate/{AuthService.getCurrentUserId()}  */}
                </Col>
            </Row>
        </div>
    )
    
}


export default RFStudentQRCode